import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Public Pages
import HomePage from "@/pages/HomePage";
import ProgrammePage from "@/pages/ProgrammePage";
import HebergementsPage from "@/pages/HebergementsPage";
import RSVPPage from "@/pages/RSVPPage";
import AccommodationPage from "@/pages/AccommodationPage";
import PaymentPage from "@/pages/PaymentPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import PrivacyPage from "@/pages/PrivacyPage";
import FAQPage from "@/pages/FAQPage";
import GuestSpacePage from "@/pages/GuestSpacePage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import PhotosPage from "@/pages/PhotosPage";

// Admin Pages
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminRSVPs from "@/pages/admin/AdminRSVPs";
import AdminAccommodations from "@/pages/admin/AdminAccommodations";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminConfig from "@/pages/admin/AdminConfig";
import AdminQuestions from "@/pages/admin/AdminQuestions";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminReminders from "@/pages/admin/AdminReminders";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminProgramme from "@/pages/admin/AdminProgramme";
import AdminFAQ from "@/pages/admin/AdminFAQ";
import AdminGuestbook from "@/pages/admin/AdminGuestbook";
import AdminGuestList from "@/pages/admin/AdminGuestList";
import AdminBrunch from "@/pages/admin/AdminBrunch";
import AdminDeliverability from "@/pages/admin/AdminDeliverability";
import AdminPhotos from "@/pages/admin/AdminPhotos";

function App() {
  return (
    <div className="App min-h-screen bg-bone">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/programme" element={<ProgrammePage />} />
          <Route path="/hebergements" element={<HebergementsPage />} />
          <Route path="/rsvp" element={<RSVPPage />} />
          <Route path="/hebergement/:rsvpId" element={<AccommodationPage />} />
          <Route path="/paiement/:rsvpId" element={<PaymentPage />} />
          <Route path="/confirmation/:rsvpId" element={<ConfirmationPage />} />
          <Route path="/confidentialite" element={<PrivacyPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/espace-invite" element={<GuestSpacePage />} />
          <Route path="/actualites" element={<BlogPage />} />
          <Route path="/actualites/:postId" element={<BlogPostPage />} />
          <Route path="/photos" element={<PhotosPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/invites" element={<AdminRSVPs />} />
          <Route path="/admin/hebergements" element={<AdminAccommodations />} />
          <Route path="/admin/paiements" element={<AdminPayments />} />
          <Route path="/admin/questions" element={<AdminQuestions />} />
          <Route path="/admin/blog" element={<AdminBlog />} />
          <Route path="/admin/relances" element={<AdminReminders />} />
          <Route path="/admin/notifications" element={<AdminNotifications />} />
          <Route path="/admin/programme" element={<AdminProgramme />} />
          <Route path="/admin/faq" element={<AdminFAQ />} />
          <Route path="/admin/livre-dor" element={<AdminGuestbook />} />
          <Route path="/admin/liste-invites" element={<AdminGuestList />} />
          <Route path="/admin/brunch" element={<AdminBrunch />} />
          <Route path="/admin/delivrabilite" element={<AdminDeliverability />} />
          <Route path="/admin/photos" element={<AdminPhotos />} />
          <Route path="/admin/configuration" element={<AdminConfig />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
